import { render } from "./RouletteHistoryElement.vue?vue&type=template&id=96c81fc8&scoped=true"
import script from "./RouletteHistoryElement.vue?vue&type=script&lang=js"
export * from "./RouletteHistoryElement.vue?vue&type=script&lang=js"

import "./RouletteHistoryElement.vue?vue&type=style&index=0&id=96c81fc8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96c81fc8"]])

export default __exports__